import { Component, OnInit } from '@angular/core';
//import { AppRoutingModule } from '../app-routing.module';

@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor( ) { }

  ngOnInit(): void {
    console.log(location.pathname);
  }

  activePath(url: string) {
    return location.pathname === url;
  }

}
